import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Button from '../Form/Button'
import { withTranslation } from 'react-i18next'

class BookingWidget extends PureComponent {

  onButtonClick = () => {
    const origin = window.location.origin
    let bookingUrl = 'https://admin.booking.com/?groups_redirect=%2Fhotel%2Fhoteladmin%2Fextranet_ng%2Fmanage%2Fchannel-manager%2Fwidget.html'
      + '?provider_id=' + this.props.providerId
      + encodeURIComponent('&origin=' + origin)
    const url = new URL(bookingUrl)
    const width = 900, height = 600
    window.open(url, this.props.providerName, 'menubar=no,location=no,resizable=yes,scrollbars=yes,status=yes,width=' + width + ',height=' + height)
  }

  render () {
    const { t } = this.props
    return (
      <Button onClick={this.onButtonClick} classNames={'Button-Full'}>{t('EASY_CONNECT')}</Button>
    )
  }
}

BookingWidget.propTypes = {
  providerId: PropTypes.number.isRequired,
  providerName: PropTypes.string.isRequired
}
export default withTranslation()(BookingWidget)
